var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-wrapper"},[_c('xrd-status-icon',{attrs:{"status":_vm.statusIconType}}),_c('div',{staticClass:"status-text"},[_vm._v(_vm._s(_vm.getStatusText(_vm.status)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }